<template>
    <div class='page-main common'>
        <a-steps :current="current" class="common-step">
            <a-step v-for="item in steps" :key="item.title" :title="item.title" ></a-step>
        </a-steps>
        <div>
            <keep-alive><component ref="withdraw" :is="steps[current].comp" :params="steps[current].params" :text="steps[current].text"></component></keep-alive>
        </div>
        <div class="model-footer-btns spaceCenter">
            <a-button v-if="current == 0" style="margin-left: 8px" class="btn-big" @click="goback">
                取消
            </a-button>
            <a-button v-if="current > 0 && current < steps.length - 1" style="margin-left: 8px" class="btn-big" @click="prev">
                上一步
            </a-button>
            <a-button v-if="current < steps.length - 2" type="primary" class="btn-big" @click="next">
                下一步
            </a-button>
            <a-button
                v-if="current == steps.length - 2"
                type="primary"
               
                class="btn-big"
                @click="success"
            >
                确认
            </a-button>
            <a-button
                v-if="current == steps.length - 1"
               
                class="btn-big"
                @click="goback"
            >
                返回账户总览
            </a-button>
        </div>
    </div>
</template>

<script>
import applay from "./applay"
import success from "@/components/steps/success"
import confirmInfo from "./confirmInfo"
import { logoutApi } from "@/api/login";
export default {
    name:"withdraw",
    components: {
        applay,success,confirmInfo
    },
    data() {
        return {
            current:0,
            steps:[
                {
                    title: '提现申请',
                    comp:"applay",
                    params:null
                },
                {
                    title: '确认信息',
                    comp:"confirmInfo",
                    params:null
                },
                {
                    title: '提现成功',
                    comp:"success",
                    text:"提现申请成功"
                },
            ]
        };
    },
    computed: {},
    methods: {
        next() {
            if(this.current == 0){ //提现申请
                this.$refs["withdraw"].check().then(res => {
                    this.current++;
                    this.steps[this.current].params = res;
                }).catch(err => {
                    console.log(err);
                });
            }   
        },
        prev() {
            this.current--;
        },
        success(){
            this.$refs["withdraw"].check().then(res => {
                this.current++;
            }).catch(err => {
                console.log(err);
            });
        },
        goback(){
            this.$router.go(-1);
        }
        
    },
    created() {},
    watch: {}
}
</script>
<style scoped>
    .common-step{
        width: 70%;
        margin:30px auto;
    }
</style>


// WEBPACK FOOTER //
// src/pages/withdraw/withdraw.vue